module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1321/floorguide/course-2-photo-9-49f7535ce1a1506d6f2e2954e1ae8923.webp";